import React, {useState, useEffect} from 'react';
import { CardMedia } from '@mui/material';
import PropTypes from 'prop-types';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
const LazyLoadCarouselItems = ({ component = 'img', maintainAspectRatio = false,  zoom, controls, height, width, image, alt, className = 'car-images', onClick, isSummaryImage, disabblePanning = false, handlePinch = () => {} }) => {
    const [aspectRatio, setAspectRatio] = useState(1);
    
    // Helper function to construct full image URL
    const getFullImageUrl = (imageUrl) => {
        if (!imageUrl) return '';
        if (imageUrl.startsWith('https')) {
            return imageUrl;
        }
        return `https://media-ae.cars24.com${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
    };
    
    const fullImageUrl = getFullImageUrl(image);

    useEffect(() => {
        if (maintainAspectRatio) {
            const calculateAspectRatio = (width, height) => width / height;
            const imageWrap = new Image();
            imageWrap.src = fullImageUrl;
            
            const handleImageLoad = () => {
                const calculatedAspectRatio = calculateAspectRatio(imageWrap.width, imageWrap.height);
                setAspectRatio(calculatedAspectRatio);
            };

            if (imageWrap.complete) { // Check if imageWrap is already loaded
                handleImageLoad();
            } else {
                imageWrap.onload = handleImageLoad; // Attach onload event listener
            }
        }
    }, [fullImageUrl, maintainAspectRatio]);
    const staticImageUrl = 'https://media-ae.cars24.com/production/consumer-web-ae/240612034847/js/223913aa7550d303df1701a360baa33d.svg';
    const renderElement = () => (
        <CardMedia key={fullImageUrl} 
        sx={{ 
            objectFit: `${(isSummaryImage || aspectRatio < 1) ? 'contain' : 'fill'} !important`, 
            backgroundImage: `${(isSummaryImage || aspectRatio < 1) ? '' : `url(${staticImageUrl})`} !important`,
            backgroundColor: `${(isSummaryImage) ? '#FFF' : `#414146`} !important`,
         }}
            component={component}
            controls={controls}
            height={height}
            width={width}
            image={fullImageUrl}
            loading="lazy"
            alt={alt}
            onClick={onClick}
            className={`bg-text ${className} lazy`}
        />
    );

    return (
        <LazyLoadComponent>
            {zoom ? 
            <TransformWrapper
                initialPositionY={150}
                panning={{ disabled: disabblePanning }} 
                onZoomStop={(ref) => handlePinch(ref)}
                maxScale={3}
                doubleClick={{ disabled: true }}
            >
                <TransformComponent wrapperStyle={{ height: `${height + 300}px`, background: '#fff', boxShadow: '0 0 0 0 #f5f5f5' }}>
                    {renderElement()}
                </TransformComponent>
            </TransformWrapper>
            : renderElement()}
        </LazyLoadComponent>
    );
};

LazyLoadCarouselItems.propTypes = {
    component: PropTypes.any,
    controls: PropTypes.bool,
    zoom: PropTypes.bool,
    image: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    isSummaryImage: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClick: PropTypes.func,
    disabblePanning: PropTypes.bool,
    handlePinch: PropTypes.func,
    maintainAspectRatio: PropTypes.bool
};

export default LazyLoadCarouselItems;
